// extracted by mini-css-extract-plugin
export var desktopMenu = "header-module--desktopMenu--bf530";
export var header = "header-module--header--666b3";
export var logoImage = "header-module--logoImage--6bdc1";
export var mainNav = "header-module--mainNav--5fa9d";
export var menu = "header-module--menu--4f3a7";
export var menuItem = "header-module--menuItem--ad5fa";
export var menuItemLink = "header-module--menuItemLink--27f4c";
export var mobileMenu = "header-module--mobileMenu--cc99b";
export var mobileMenuControl = "header-module--mobileMenuControl--4cd39";
export var mobileMenuLabel = "header-module--mobileMenuLabel--ce918";
export var mobileMenuNav = "header-module--mobileMenuNav--76849";
export var navbar = "header-module--navbar--93035";